import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { ArticlesService } from '../../../services/articles.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-articles-all',
    templateUrl: './articles-all.component.html',
    styleUrls: ['./articles-all.component.scss']
})
export class ArticlesAllComponent implements OnInit {

    pagecode: string = "article-all";
    module: string = "articles";
    Menu: any[];
    pagetitle: string;

    accessdenied: boolean = false;
    isLoading: boolean = true;
    articles: any[] = [];
    isLoaded: boolean = false;

    search_text: string = " ";

    constructor(private authentication: AuthenticationService, private route: ActivatedRoute, private _router: Router, private _commonService: CommonService, private _articlesService: ArticlesService) { }

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            debugger;
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

          

                        this.getArticles(1);

                        window.scroll(0, 0);
                    }
                    else {
                        this.accessdenied = true;
                        this.isLoading = false;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                    this.isLoading = false;
                }
            );
        });
    }

    getArticles(page: any) {
        this._articlesService.getArticles(page).subscribe(
            (res: any) => {
                if (res.success) {
                    console.log("res", res);
                    if (res.data != null) {
                        for (var i = 0; i < res.data.length; i++) {
                            this.articles.push(res.data[i]);
                        }
                        if (res.data.length > 0) {
                            this.getArticles(page + 1);
                        }
                        else {
                            this.search_text = "";
                            this.isLoading = false;
                            this.isLoaded = true;
                        }
                    }
                }
            },
            (err: any) => {
                console.error("Web/ArticlesBox/getArticles()", err);
            }
        );
    }

    openArticle(id: any, navigate: boolean) {
        if (!navigate) {
            this._articlesService.updateViewCount(id).subscribe(
                (res: any) => { },
                (err: any) => {
                    console.error("Web/Articles/All/updateViewCount()", err);
                }
            );
        }
        if (navigate)
            this._router.navigate(['articles/detail/' + id])
    }

  

}
